import React, { useEffect } from 'react';
import ContactUsPage from '../components/contact/ContactUsPage';
import FAQPage from '../components/contact/FAQPage';
import SEO from '../components/SEO';

const Contact = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const breadcrumbs = [
        { name: "Home", url: "/" },
        { name: "Contact Us", url: "/get-in-touch-skill-ascent" }
    ];

    const contactSchema = {
        "@context": "https://schema.org",
        "@graph": [
            {
                "@type": "ContactPage",
                "name": "Contact Skill Ascent | Inquire About Courses & Admissions",
                "url": "https://www.skillascent.in/get-in-touch-skill-ascent",
                "description": "Get in touch with Skill Ascent for admissions, course inquiries, syllabus downloads, demo classes, and career counseling.",
                "mainEntity": {
                    "@type": "EducationalOrganization",
                    "name": "Skill Ascent",
                    "url": "https://www.skillascent.in/",
                    "email": "info@skillascent.in",
                    "telephone": "+91-8297222303",
                    "address": {
                        "@type": "PostalAddress",
                        "streetAddress": "D.NO.16-58/33, Sai Sadan, Hanuman Nagar",
                        "addressLocality": "Eluru",
                        "addressRegion": "Andhra Pradesh",
                        "postalCode": "534001",
                        "addressCountry": "IN"
                    }
                }
            },
            {
                "@type": "FAQPage",
                "mainEntity": [
                    {
                        "@type": "Question",
                        "name": "What is Skill Ascent?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "Skill Ascent is a professional online learning platform that provides industry-oriented certification courses designed to help students, graduates, and working professionals upgrade their skills and advance their careers."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "Who can enroll in Skill Ascent courses?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "Anyone can enroll - students, fresh graduates, job seekers, working professionals, entrepreneurs, and career switchers across IT, Design, Engineering, Agriculture, and Healthcare streams."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "Are Skill Ascent courses suitable for beginners?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "Yes, Skill Ascent offers beginner-level foundational courses, intermediate skill enhancement programs, and advanced specialization training with hands-on projects."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "Will I receive an industry-recognized certificate?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "Yes, learners receive a recognized course completion certificate upon successfully completing project submissions and assessments to enhance resumes and LinkedIn profiles."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "Does Skill Ascent provide placement assistance?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "Yes, career-focused programs include resume building, mock interviews, LinkedIn profile optimization, and job referrals."
                        }
                    }
                ]
            }
        ]
    };

    return (
        <>
            <SEO
                title="Contact Skill Ascent | Admissions, Demo Booking & Course Inquiry"
                description="Have questions about our certification courses? Reach out to the Skill Ascent team for course schedules, syllabus details, free live demo classes, and career guidance."
                keywords="contact skill ascent, course admissions, IT training inquiry, demo class booking, edtech course support"
                canonicalPath="/get-in-touch-skill-ascent"
                schemaData={contactSchema}
                breadcrumbs={breadcrumbs}
            />
            <ContactUsPage />
            <FAQPage />
        </>
    );

};

export default Contact;